import { GetServerSidePropsContext } from "next";

import { API_BASE, API_URL } from "@/constants";
import { User } from "@/types/api/user";
import { getApiError } from "@/utils/api-error";

import { ProfileUpdateRequest } from "./types";

const PROFILE_ENDPOINT = `${API_URL}${API_BASE}/profile`;

export async function getProfile(cookie?: string): Promise<User> {
  const response = await fetch(
    PROFILE_ENDPOINT,
    cookie ? { headers: { cookie } } : undefined
  );

  if (!response.ok) {
    throw await getApiError(response);
  }

  return response.json();
}

export async function putProfile(body: ProfileUpdateRequest): Promise<User> {
  const response = await fetch(PROFILE_ENDPOINT, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw await getApiError(response);
  }

  return response.json();
}

export async function userIsBusinessAccountHolder(
  req: GetServerSidePropsContext["req"]
) {
  const cookie = req.headers.cookie;
  if (!cookie) {
    return null;
  }
  try {
    const user = await getProfile(cookie);
    return user.account_type === "business";
  } catch (_) {
    return null;
  }
}
